type BillingCycle = "monthly" | "yearly";

type BillingToggleProps = {
  value: BillingCycle;
  onChange: (value: BillingCycle) => void;
  yearlyDisabled?: boolean;
  yearlyDescriptionId?: string;
};

export default function BillingToggle({
  value,
  onChange,
  yearlyDisabled = false,
  yearlyDescriptionId,
}: BillingToggleProps) {
  return (
    <div
      className="inline-flex rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm"
      role="group"
      aria-label="Período de cobrança"
    >
      <button
        type="button"
        aria-pressed={value === "monthly"}
        onClick={() => onChange("monthly")}
        className={`rounded-xl px-6 py-2.5 text-sm font-bold transition-all ${
          value === "monthly"
            ? "bg-blue-600 text-white shadow-[0_6px_18px_rgba(37,99,235,0.25)]"
            : "text-slate-600 hover:text-blue-600"
        }`}
      >
        Mensal
      </button>

      <button
        type="button"
        aria-pressed={value === "yearly"}
        disabled={yearlyDisabled}
        aria-describedby={yearlyDescriptionId}
        onClick={() => onChange("yearly")}
        className={`rounded-xl px-6 py-2.5 text-sm font-bold transition-all disabled:cursor-not-allowed disabled:text-slate-400 ${
          value === "yearly"
            ? "bg-blue-600 text-white shadow-[0_6px_18px_rgba(37,99,235,0.25)]"
            : "text-slate-600 hover:text-blue-600"
        }`}
      >
        Anual
      </button>
    </div>
  );
}
